import { Collapse } from "bootstrap";

export function addScrollToRootElement() {
  const root = document.getElementById("root");
  const scrollUp = "scroll-up";
  const scrollDown = "scroll-down";
  let lastScroll = 0;

  window.addEventListener("scroll", () => {
    const currentScroll = window.pageYOffset;
    if (currentScroll <= 200) {
      root.classList.remove(scrollUp);
      return;
    }

    if (currentScroll > lastScroll && !root.classList.contains(scrollDown)) {
      // down
      root.classList.remove(scrollUp);
      root.classList.add(scrollDown);
    } else if (currentScroll < lastScroll && root.classList.contains(scrollDown)) {
      // up
      root.classList.remove(scrollDown);
      root.classList.add(scrollUp);
    }
    lastScroll = currentScroll;
  });

  let topLink = document.getElementById("top-link");

  topLink.addEventListener("click", () => {
    root.classList.remove(scrollUp);
    root.classList.remove(scrollDown);
  });
}

export function addClassesToRootElement(classes) {
  let root = document.getElementById("root");
  root.removeAttribute("class");
  for (let i = 0; i < classes.length; i++) {
    root.classList.add(classes[i]);
  }
}

export function addClassesToBodyElement(classes) {
  let body = document.getElementsByTagName("body")[0];
  body.removeAttribute("class");
  for (let i = 0; i < classes.length; i++) {
    body.classList.add(classes[i]);
  }
}

export function getHeroSliderStartPosition() {
  const heroSlider = document.querySelector(".hero_slider");
  if (!heroSlider) return;

  let fullHash = window.location.hash;
  let hash = fullHash.split("?");

  let startAt;
  if (hash[0] !== "") {
    let slide = document.querySelector(`[data-id="${hash[0]}"]`);
    startAt = parseInt(slide.dataset.nr) > -1 ? parseInt(slide.dataset.nr + 1) : 0;
  } else {
    startAt = 0;
  }

  if (startAt > 0) {
    heroSlider.classList.add("hide-images");
    setTimeout(() => {
      heroSlider.classList.remove("hide-images");
      window.scrollTo({
        top: 0, // scroll so that the element is at the top of the view
        behavior: "smooth", // smooth scroll
      });
    }, 1000);
  }
  return startAt;
}

export function setMenuScrollVisibility() {
  const mobileNavMore = document.getElementById("mobile-nav_more");
  const mobileNav = document.getElementById("mobile-nav");
  const hamburger = document.getElementById("hamburger");
  const navbar = document.querySelector(".navbar");

  if (window.pageYOffset > 35) {
    navbar.classList.add("nav__color__change");
  }

  /* MENU */
  mobileNavMore.addEventListener("show.bs.collapse", function () {
    hamburger.classList.add("is-active");
  });

  mobileNavMore.addEventListener("hidden.bs.collapse", function () {
    mobileNav.classList.remove("hide");
  });
  //shown.bs.collapse

  mobileNavMore.addEventListener("hide.bs.collapse", function () {
    hamburger.classList.remove("is-active");
  });

  /* SCROLL */
  const body = document.body;
  const scrollUp = "scroll-up";
  const scrollDown = "scroll-down";
  let lastScroll = 0;

  window.addEventListener(
    "scroll",
    () => {
      const currentScroll = window.pageYOffset;

      if (mobileNavMore.classList.contains("show")) {
        const navCollapse = Collapse.getInstance(mobileNavMore);
        navCollapse.hide();
      }

      if (currentScroll > 25 && !navbar.classList.contains("nav__color__change")) {
        navbar.classList.add("nav__color__change");
      }

      if (currentScroll <= 25 && navbar.classList.contains("nav__color__change")) {
        navbar.classList.remove("nav__color__change");
      }

      if (currentScroll > lastScroll && !navbar.classList.contains("hide") && currentScroll > 120) {
        navbar.classList.add("hide");
      } else if (currentScroll < lastScroll && navbar.classList.contains("hide")) {
        navbar.classList.remove("hide");
      }
      lastScroll = currentScroll;
    },
    {
      passive: true,
    }
  );

  let topLink = document.getElementById("top-link");

  if (topLink) {
    topLink.addEventListener("click", () => {
      body.classList.remove(scrollUp);
      body.classList.remove(scrollDown);
    });
  }
}
